import type { SeatInfo } from "@app/protocol";
import type { ToastTone } from "../components/Toast";
import type { T } from "./tableText";

/** What the games' hand-end toasts share. */

export type Seats = readonly (SeatInfo | null)[];

/** "+40", "0", "−60": a real minus sign (U+2212), which lines up with the plus and is read as "minus". */
export const signed = (n: number) => (n > 0 ? `+${n}` : String(n).replace("-", "\u2212"));

/** "Us +51 · Them −40", your team first. */
export function teamsLine(deltas: readonly number[], yourSeat: number, t: T): string {
  const us = yourSeat % 2 === 0 ? 0 : 1;
  return t("spades.handEnd", {
    us: signed(deltas[us] ?? 0),
    them: signed(deltas[1 - us] ?? 0),
  });
}

export function toneOf(delta: number): ToastTone {
  if (delta > 0) return "success";
  return delta < 0 ? "error" : "neutral";
}
